module.exports = __webpack_public_path__ + "static/media/lc.a08d76ea.webp";